
define('jst!conversations/_divider',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="divider <%= dividerText ? "" : "no-text" %>">\n  <% if(dividerText) { %>\n    <span class="divider-text"><%= dividerText %></span>\n  <% } %>\n</div>\n');
 });

